export default __webpack_public_path__ + "static/media/success.05175df7.svg";